// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2AMxw","box":"WorkspacesBox_box__33kzr","node":"WorkspacesBox_node__3upeJ"};